import React from "react";
import LegalLayout from "../LegalLayout";

export default function CGU() {
  return (
    <LegalLayout testid="cgu-page" eyebrow="Légal" title="Conditions d'utilisation" lastUpdate="14 octobre 2026">
      <h2>Acta Documentum — Projet Ego Automata</h2>
      <p>
        Acta Documentum est une application développée dans le cadre du projet
        entrepreneurial <strong>Ego Automata</strong>, actuellement en cours de création.
        Elle est utilisée pour des tests privés par des salariés et prestataires
        travaillant pour <strong>LIRAH SAS</strong>. Alma France est un projet de
        société non encore constituée.
      </p>
      <p>
        Les conditions d'utilisation détaillées et les informations juridiques
        font actuellement l'objet d'une mise à jour.
      </p>
      <h2>Utilisation</h2>
      <p>
        L'accès à l'application de test est réservé aux salariés et prestataires autorisés.
        Chaque utilisateur doit préserver la confidentialité de ses identifiants
        et utiliser les données et documents auxquels il accède uniquement
        dans le cadre de ses autorisations.
      </p>
      <p>
        Aucune condition d'abonnement commercial ou de facturation
        n'est annoncée dans le cadre de cette utilisation pilote.
      </p>
      <h2>Contact</h2>
      <p><a href="mailto:contact@acta-documentum.fr">contact@acta-documentum.fr</a></p>
    </LegalLayout>
  );
}
